// antd 4.9.4 → 4.20+ items API 兼容 wrapper
// 让我们的 demo 代码用新版 items prop API 写,自动转换成老版 children API

import React from 'react';
import { Tabs as AntdTabs } from 'antd';

interface TabItem {
  key: string;
  label: React.ReactNode;
  children?: React.ReactNode;
}

interface TabsProps {
  defaultActiveKey?: string;
  activeKey?: string;
  items?: TabItem[];
  onChange?: (key: string) => void;
  type?: 'line' | 'card';
  size?: 'small' | 'middle' | 'large';
}

export const Tabs: React.FC<TabsProps> = ({ items, ...rest }) => {
  if (!items) return <AntdTabs {...rest} />;
  return (
    <AntdTabs {...rest}>
      {items.map(item => (
        <AntdTabs.TabPane tab={item.label} key={item.key}>
          {item.children}
        </AntdTabs.TabPane>
      ))}
    </AntdTabs>
  );
};
